import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PosterOne from "../share/component.jsx/posterone";
import aboutbanner from "../assets/aboutbanner.jpg";
import BannerOne from "../share/component.jsx/banner";

const PRODUCTS = [
  { id: 1, image: require('../assets/services/Pharmaceutical Consulting.jpg'), name: "Pharmaceutical Consulting", desc: "Our pharmaceutical consulting support services assist businesses in the review of cardiovascular drugs, pathways, safety issues, drug interactions, and patient care. We support teams across the Pharmaceutical & Biotech Industry with real-world medical expertise, clinical evidence review, and product positioning." },
  { id: 2, image: require('../assets/services/Medical Device Advisory.jpg'), name: "Medical Device Advisory", desc: "We provide both clinical and technical counsel for the Medical Device Industry, with special regard for cardiac devices. We help companies with pacemakers, ICDs, stents, monitoring devices, and cardiovascular technologies to better grasp clinical use, product safety, and physician and patient applications." },
  { id: 3, image: require('../assets/services/Clinical Trial Design.jpg'), name: "Clinical Trial Design", desc: "We help to plan clinical trials for cardiovascular devices and pharmaceuticals. We support the development of the protocol, the selection of endpoints, eligibility criteria, risk planning, and evidence generation to satisfy scientific, medical, and regulatory requirements." },
  { id: 4, image: require('../assets/services/Product Development.jpg'), name: "Product Development", desc: "We provide product development consulting to medical device and pharmaceutical companies to get them from concept to practical solution. We offer clinical need assessment, value review, competitive positioning, and physician feedback planning." },
  { id: 5, image: require('../assets/services/Regulatory Affairs.jpg'), name: "Regulatory Affairs", desc: "We support companies in the FDA, CE mark, and international regulatory submissions of cardiovascular products. Our support consists of document review, evidence alignment, clinical data preparation, guidance on safety reporting, and submission strategy." },
  { id: 6, image: require('../assets/services/KOL Engagement.jpg'), name: "KOL Engagement", desc: "We facilitate the relationship of companies with key opinion leaders in cardiology and cardiovascular medicine. These specialists can be used for product validation, advisory boards, clinical feedback, peer review, and educational discussions." },
];

const BENEFITS = [
  { num: "01", title: "Regulatory Expertise", desc: "We facilitate companies in navigating often-complicated approval processes and offer guidance from seasoned regulatory and clinical experts. Our team helps you to document, plan evidence, and prepare your submission, as well as to review for compliance, enabling your product to proceed with confidence." },
  { num: "02", title: "Clinical Validation", desc: "We provide excellent clinical planning, research review, trial strategy, and medical input for evidence-based product validation. This assists companies in demonstrating product safety, performance, and value in a transparent and systematic manner." },
  { num: "03", title: "Market Access", desc: "We assist companies in strategically planning the way forward to global markets with cardiovascular products. Our consultation is tailored around clinical value, regulatory requirements, physician uptake, and patient benefit, facilitating a more seamless product positioning." },
  { num: "04", title: "Post-Market Support", desc: "Post Product-Life Support includes Safety Surveillance, Compliance Review, Performance Reporting, and improvement planning. This aids companies in keeping their products of good quality, live up to regulatory requirements, and address clinical needs in practice." },
];

export default function MedicalDeviceConsultation() {
  const navigate = useNavigate();
  const [activeBenefit, setActiveBenefit] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setActiveBenefit(p => (p + 1) % BENEFITS.length), 3000);
    return () => clearInterval(t);
  }, []);

  return (
    <>
     <BannerOne
  img={require('../assets/symptoms/deviceBanner.png')}
  title={
    <>
      Medical Device <br /> & <br />
      Pharmaceutical Consultation
    </>
  }
/>
      <div className="service-root acc-root">
        
        <section className="service-section">
          <div className="service-container">
            <p className="service-eyebrow">What We Offer</p>
            <h2 className="service-heading">Comprehensive <em>Product</em> Consulting Services</h2>
            <p className="service-subtitle">For medical device and pharmaceutical companies seeking to develop, validate, enhance, and launch cardiovascular products, we offer our customers an end-to-end consultation. Our team helps with product strategy, clinical planning, regulatory preparation, and medical review. By leveraging extensive industry expertise, we assist businesses in developing more patient-friendly, market-friendly, and evidence-based solutions for patients and healthcare professionals.</p>
            <div className="service-grid">
              {PRODUCTS.map(p => (
                <div key={p.id} className="service-card">
                  <div style={{ width: 70, height: 70, borderRadius: 14,  display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", marginBottom: 15 }}>
          {p.image ? (
            <img src={p.image} alt={p.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          ) : (
            <span style={{ fontSize: 24 }}>{p.icon}</span>
          )}
        </div>
                  <h3>{p.name}</h3>
                  <p>{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="service-section service-section-alt">
          <div className="service-container">
            <div className="service-benefits">
              <div className="service-benefit-list">
                <p className="service-eyebrow">Why Choose Us</p>
                <h2 className="service-heading">Partner with <em>Industry Experts</em></h2>
                {BENEFITS.map((b, i) => (
                  <div key={b.num} className={`service-benefit-item ${activeBenefit === i ? 'active' : ''}`} onClick={() => setActiveBenefit(i)}>
                    <div className="service-benefit-num">{b.num}</div>
                    <div className="service-benefit-title">{b.title}</div>
                    <div className="service-benefit-desc">{b.desc}</div>
                  </div>
                ))}
              </div>
              <div className="service-benefit-visual">
                <h4>{BENEFITS[activeBenefit].title}</h4>
                <p>{BENEFITS[activeBenefit].desc}</p>
              </div>
            </div>
          </div>
        </section>

        <section className="service-section service-cta">
          <div className="service-container">
            <h2>Ready to Transform Your Product?</h2>
            <p>Call us today to talk about your medical device or pharmaceutical consultation needs. We will be discussing your objectives, your product, and the stage your product is in, and help you to be treated in a clinically relevant and practical manner.</p>
            <button className="service-btn-primary" onClick={() => navigate('/consultations')}>Get Started</button>
          </div>
        </section>
      </div>
    </>
  );
}